















import { useEffect, useState } from "react";
import TaskDrawer from "../../components/Tasks/TaskDrawer";
import CreateTaskModal from "../../components/Tasks/CreateTaskModal";
import { getAssignedTasksApi, getMyReportingApi, getMyTasksApi, getTeamDailyWorkLogsApi, updateTaskStatusApi, deleteTaskApi } from "../../app/api";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import TaskSubtasks from "../../components/Tasks/TaskSubtasks";

import { createPortal } from "react-dom";
import { toast } from "react-toastify";
import { useRef } from "react";
import { motion } from "framer-motion";
import { CalendarDays, ChevronDown, ClipboardCheck, MoreVertical, Sparkles, Pin, PinOff, Pencil, Trash2, Search } from "lucide-react";
import { formatDisplayDateTime, getDateInputValue, getTodayDateInputValue } from "../../utils/dateFormat";

const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
export default function UsersTask() {
  const [openMenuId, setOpenMenuId] = useState(null);

  const scrollRef = useRef(null);
  const isDown = useRef(false);
  const startX = useRef(null);
  const scrollLeft = useRef(null);

  const [expandedTasks, setExpandedTasks] = useState([]);

  const toggleDescription = (taskId) => {
    setExpandedTasks((prev) =>
      prev.includes(taskId)
        ? prev.filter((id) => id !== taskId)
        : [...prev, taskId]
    );
  };

  const handleMouseDown = (e) => {
    isDown.current = true;
    startX.current = e.pageX - scrollRef.current.offsetLeft;
    scrollLeft.current = scrollRef.current.scrollLeft;
  };

  const handleMouseLeave = () => {
    isDown.current = false;
  };

  const handleMouseUp = () => {
    isDown.current = false;
  };

  const handleMouseMove = (e) => {
    if (!isDown.current) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.5;
    scrollRef.current.scrollLeft = scrollLeft.current - walk;
  };

  const parseTaskAssignees = (task = {}) => {
    const raw = task.assigned_users || task.assignee || task.assignees;
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "object") return [raw];

    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch {
      try {
        return JSON.parse(`[${raw}]`);
      } catch {
        return [];
      }
    }
  };

  const getAssignees = (task) => {
    const parsedAssignees = parseTaskAssignees(task).map((assignee) => ({
      name: assignee.name || `${assignee.first_name || ""} ${assignee.last_name || ""}`.trim(),
      id: assignee.id,
      pic: assignee.profile_pic || assignee.pic || null,
      job_title: assignee.job_title || "",
    })).filter((assignee) => assignee.name);

    if (parsedAssignees.length) return parsedAssignees;

    const ids = String(task.assigned_to_ids || "")
      .split(",")
      .map((value) => value.trim());
    const names = String(task.assigned_to_names || "")
      .split(",")
      .map((value) => value.trim());
    const pics = String(task.assigned_to_profile_pics || "")
      .split(",")
      .map((value) => value.trim());

    return names
      .map((name, index) => ({
        name,
        id: ids[index] || ids[0] || "",
        pic: pics[index] || "",
        job_title: "",
      }))
      .filter((assignee) => assignee.name);
  };

  const scrollLeftBtn = () => {
    scrollRef.current.scrollBy({
      left: -300,
      behavior: "smooth",
    });
  };

  const scrollRightBtn = () => {
    scrollRef.current.scrollBy({
      left: 300,
      behavior: "smooth",
    });
  };

  // const [showReasonError, setShowReasonError] = useState(false);
  const [showReasonError, setShowReasonError] = useState(false);

  const [showSuccessModal, setShowSuccessModal] = useState(false);




  const [deleteTaskId, setDeleteTaskId] = useState(null);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);


  // const handleUpdate = async () => {
  //   // ✅ check if date changed
  //   const isDateChanged =
  //     editData.due_date &&
  //     editData.due_date !== editingTask?.due_date?.split(" ")[0];

  //   // ❌ if changed but no reason
  //   if (isDateChanged && !editData.reason?.trim()) {
  //     toast.error("Reason is required when changing end date");

  //     // optional: highlight field
  //     setShowReasonError(true);
  //     return;
  //   }

  //   try {
  //     await updateTaskStatusApi(editingTask.id, editData);

  //     setEditingTask(null);
  //     setShowSuccessModal(true); // 🔥 open success modal
  //     refreshTasks();
  //   } catch (err) {
  //     toast.error("Failed to update task");
  //   }
  // };

  const handleUpdate = async () => {
    const originalDate = getDateInputValue(editingTask?.due_date);
    const newDate = editData.due_date;

    const isDateChanged = newDate && newDate !== originalDate;

    // ❌ If changed but no reason
    if (isDateChanged && !editData.reason?.trim()) {
      toast.error("Reason is required when changing end date");
      setShowReasonError(true);
      return;
    }

    try {
      // 👇 build payload dynamically
      const payload = {
        title: editData.title,
        description: editData.description,
        status: editData.status,
      };

      // ✅ ONLY send when changed
      if (isDateChanged) {
        payload.due_date = newDate;
        payload.reason = editData.reason;
      }

      await updateTaskStatusApi(editingTask.id, payload);

      setEditingTask(null);
      setShowSuccessModal(true);
      refreshTasks();

    } catch (err) {
      toast.error("Failed to update task");
    }
  };


  const [editingTask, setEditingTask] = useState(null);
  const [editData, setEditData] = useState({
    title: "",
    description: "",
    status: "",
  });




  const navigate = useNavigate();   // 👈 ADD THIS
  const loggedInUser = JSON.parse(localStorage.getItem("user") || "{}");
  const [tasks, setTasks] = useState([]);
  const [teamTasks, setTeamTasks] = useState([]);
  const [teamTaskSearch, setTeamTaskSearch] = useState("");
  const [teamDailyLogs, setTeamDailyLogs] = useState([]);
  const [teamDailyDate, setTeamDailyDate] = useState(() => getTodayDateInputValue());
  const [selectedTeamMember, setSelectedTeamMember] = useState("ALL");
  const [teamDailySearch, setTeamDailySearch] = useState("");
  const [teamWorkTab, setTeamWorkTab] = useState("TODAY");
  const [teamDailyOpen, setTeamDailyOpen] = useState(true);

  const [selectedSubtaskTask, setSelectedSubtaskTask] = useState(null);
  const [filter, setFilter] = useState("IN_PROGRESS");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [canCreateUserTasks, setCanCreateUserTasks] = useState(false);
  const [canViewTeamWork, setCanViewTeamWork] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  // const refreshTasks = async () => {
  //   const res = await getMyTasksApi();
  //   setTasks(res?.data || []);
  // };

  const refreshTasks = async () => {
    const res = await getMyTasksApi();

    const parsedTasks = (res?.data || []).map((task) => ({
      ...task,
      assignee: parseTaskAssignees(task),
    }));

    setTasks(parsedTasks);
  };

  useEffect(() => {
    refreshTasks();
  }, []);

  useEffect(() => {
    let mounted = true;

    const loadCreatePermission = async () => {
      if (mounted) setCanCreateUserTasks(true);

      const isAdmin = [1, 2, 3].includes(Number(loggedInUser?.role_id));
      if (isAdmin) {
        if (mounted) setCanViewTeamWork(true);
        return;
      }

      try {
        const res = await getMyReportingApi();
        const hasTeamMembers = (res?.data?.teamMembers || []).length > 0;
        if (mounted) setCanViewTeamWork(hasTeamMembers);
      } catch {
        if (mounted) setCanViewTeamWork(false);
      }
    };

    loadCreatePermission();

    return () => {
      mounted = false;
    };
  }, [loggedInUser?.id, loggedInUser?.role_id]);



  // ✅ FIRST define pinnedTasks
  const [pinnedTasks, setPinnedTasks] = useState(() => {
    const saved = localStorage.getItem("pinnedTasks");
    return saved ? JSON.parse(saved) : [];
  });

  // ✅ THEN use it
  const filteredTasks = tasks
    .filter((task) => {
      if (filter === "ALL") return task.status !== "DONE";
      if (filter === "DONE") return task.status === "DONE";
      if (filter === "IN_PROGRESS") return task.status === "IN_PROGRESS";
      return true;
    })
    .sort((a, b) => {
      const aPinned = pinnedTasks.includes(a.id);
      const bPinned = pinnedTasks.includes(b.id);

      if (aPinned && !bPinned) return -1;
      if (!aPinned && bPinned) return 1;

      return new Date(b.created_at) - new Date(a.created_at);
    });


  const location = useLocation();



  useEffect(() => {
    if (location.state?.openCreate) {
      setShowCreateModal(true);

      // clear state so it doesn't reopen
      navigate(location.pathname, { replace: true });
    }

    if (location.state?.taskId && tasks.length > 0) {
      const foundTask = tasks.find(
        (t) => String(t.id) === String(location.state.taskId)
      );

      if (foundTask) {
        setSelectedTask(foundTask);
        navigate(location.pathname, { replace: true, state: {} });
      }
    }
  }, [location.state, tasks, navigate, location.pathname]);




  useEffect(() => {
    localStorage.setItem("pinnedTasks", JSON.stringify(pinnedTasks));
  }, [pinnedTasks]);

  useEffect(() => {
    if (!canViewTeamWork) {
      setTeamDailyLogs([]);
      setTeamTasks([]);
      return;
    }

    let mounted = true;

    const loadTeamDailyLogs = async () => {
      const [dailyRes, tasksRes] = await Promise.all([
        getTeamDailyWorkLogsApi(teamDailyDate),
        getAssignedTasksApi(),
      ]);
      const assignedTasks = (tasksRes?.data || []).filter(
        (task) => Number(task.created_by) === Number(loggedInUser?.id)
      );

      if (mounted) {
        setTeamDailyLogs(dailyRes?.data || []);
        setTeamTasks(
          assignedTasks.map((task) => ({
            ...task,
            assignee: parseTaskAssignees(task),
          }))
        );
      }
    };

    loadTeamDailyLogs();

    return () => {
      mounted = false;
    };
  }, [canViewTeamWork, loggedInUser?.id, teamDailyDate]);

  const togglePin = (taskId) => {
    setPinnedTasks((prev) =>
      prev.includes(taskId)
        ? prev.filter((id) => id !== taskId)
        : [...prev, taskId]
    );
  };

  const isRecentlyAssignedToMe = (task) => {
    if (!task?.created_at || !loggedInUser?.id) return false;
    if (String(task.created_by || "") === String(loggedInUser.id)) return false;
    if (task.status === "DONE") return false;

    const createdAt = new Date(String(task.created_at).replace(" ", "T"));
    if (Number.isNaN(createdAt.getTime())) return false;

    const sevenDays = 7 * 24 * 60 * 60 * 1000;
    return Date.now() - createdAt.getTime() <= sevenDays;
  };

  const getFullName = (user = {}) =>
    `${user.first_name || ""} ${user.last_name || ""}`.trim() || "Team member";

  const isLoggedInUser = (id) => String(id || "") === String(loggedInUser?.id || "");
  const reporteeDailyLogs = teamDailyLogs.filter((log) => !isLoggedInUser(log.user_id));

  const teamMemberOptions = Array.from(
    new Map(
      [
        ...reporteeDailyLogs.map((log) => [
          String(log.user_id),
          {
            id: String(log.user_id),
            name: getFullName(log.user),
          },
        ]),
        ...teamTasks.flatMap((task) =>
          getAssignees(task)
            .filter((assignee) => !isLoggedInUser(assignee.id))
            .map((assignee) => [
              String(assignee.id),
              {
                id: String(assignee.id),
                name: assignee.name,
              },
            ])
        ),
      ]
    ).values()
  );

  const visibleTeamDailyLogs =
    (selectedTeamMember === "ALL"
      ? reporteeDailyLogs
      : reporteeDailyLogs.filter((log) => String(log.user_id) === String(selectedTeamMember)))
      .filter((log) => {
        const search = teamDailySearch.trim().toLowerCase();
        if (!search) return true;
        const userName = getFullName(log.user).toLowerCase();
        const title = String(log.task_title || log.custom_title || "").toLowerCase();
        const plan = String(log.morning_description || "").toLowerCase();
        return userName.includes(search) || title.includes(search) || plan.includes(search);
      });

  const visibleTeamTasks = teamTasks
    .filter((task) => task.status !== "DONE")
    .filter((task) => getAssignees(task).some((assignee) => !isLoggedInUser(assignee.id)))
    .filter((task) =>
      selectedTeamMember === "ALL"
        ? true
        : getAssignees(task).some((assignee) => String(assignee.id) === String(selectedTeamMember))
    )
    .filter((task) => {
      const search = teamTaskSearch.trim().toLowerCase();
      if (!search) return true;
      const assignees = getAssignees(task).map((assignee) => assignee.name).join(" ").toLowerCase();
      return (
        String(task.title || "").toLowerCase().includes(search) ||
        String(task.description || "").toLowerCase().includes(search) ||
        assignees.includes(search)
      );
    });



  return (
    <div
      className="
  relative
  w-full
  bg-gradient-to-br
  from-[#1e1447]
  via-[#24155a]
  to-[#12082f]
  p-6
  rounded-[24px]
  overflow-hidden
  mt-[-44px] md:mt-0
"
    >
      <style>{`
        @keyframes uptaskNewTaskBorder {
          to {
            transform: rotate(360deg);
          }
        }

        .uptask-new-task-card::before {
          content: "";
          position: absolute;
          inset: -2px;
          border-radius: 22px;
          padding: 2px;
          background: conic-gradient(
            from 0deg,
            transparent 0deg,
            rgba(255, 255, 255, 0.95) 42deg,
            rgba(250, 204, 21, 0.98) 72deg,
            transparent 112deg,
            transparent 360deg
          );
          -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          pointer-events: none;
          animation: uptaskNewTaskBorder 1.6s linear infinite;
          z-index: 1;
        }

        .uptask-new-task-card::after {
          content: "";
          position: absolute;
          inset: 0;
          border-radius: 20px;
          border: 1px solid rgba(254, 240, 138, 0.78);
          box-shadow: 0 0 24px rgba(250, 204, 21, 0.38), inset 0 0 22px rgba(255, 255, 255, 0.08);
          pointer-events: none;
          z-index: 1;
        }
      `}</style>
      <div className="absolute top-20 left-20 w-72 h-72 bg-white/20 rounded-full blur-3xl opacity-20 pointer-events-none"></div>
      <div className="absolute bottom-10 right-10 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl opacity-20 pointer-events-none"></div>

      {/* ===== HEADER & FILTERS ===== */}
      <div className="flex flex-col md:flex-row items-center justify-between mb-4 gap-4 relative z-20">
        <div className="flex-1 w-full flex justify-start">
          <h2 className="text-2xl font-semibold text-white whitespace-nowrap">
            My Tasks
          </h2>
        </div>

        <div className="flex-1 flex justify-center w-full">
          {/* Filter Pill */}
          <div className="flex items-center bg-white/10 p-1 rounded-xl border border-white/10 backdrop-blur-md relative z-20 shadow-lg">
            {["ALL", "IN_PROGRESS", "DONE"].map((tab) => (
              <button
                key={tab}
                onClick={() => setFilter(tab)}
                className={`
                  px-5 py-2 text-xs font-bold rounded-lg
                  transition-all duration-300
                  ${
                    filter === tab
                      ? "bg-indigo-600 text-white shadow-md scale-105"
                      : "text-white/60 hover:text-white/90 hover:bg-white/5"
                  }
                `}
              >
                {tab === "IN_PROGRESS" ? "In Progress" : tab === "DONE" ? "Completed" : "All"}
              </button>
            ))}
          </div>
        </div>

        {canCreateUserTasks && (
        <div className="flex-1 w-full flex justify-end">
          <button
            onClick={() => setShowCreateModal(true)}
            className="px-5 py-2 text-xs font-bold rounded-xl bg-gradient-to-r from-cyan-500 to-blue-500 text-white shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            + Create Task
          </button>
        </div>
        )}
      </div>

      {/* ===== TASK LIST ===== */}
      <div className="relative mt-[-24px]">
        {filteredTasks.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 text-white/40">
            <Sparkles size={48} className="mb-4 opacity-20" />
            <p className="text-lg font-medium">No tasks available</p>
          </div>
        ) : (
          <>
            {/* Left Arrow */}
            <button
              onClick={scrollLeftBtn}
              className="absolute left-[-20px] top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-md text-white p-2 rounded-full shadow-xl transition-all"
            >
              ←
            </button>

            {/* Right Arrow */}
            <button
              onClick={scrollRightBtn}
              className="absolute right-[-20px] top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-md text-white p-2 rounded-full shadow-xl transition-all"
            >
              →
            </button>

            {/* SLIDER */}
            <div
              ref={scrollRef}
              className="flex gap-4 overflow-x-auto py-10 px-8 no-scrollbar cursor-grab active:cursor-grabbing select-none ml-[-28px]"
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
            >
              {filteredTasks.map((task) => {
                const todayDate = getTodayDateInputValue();
                const dueDate = getDateInputValue(task.due_date);

                let deadlineStatus = null;

                if (dueDate && task.status !== "DONE" && task.status !== "HOLD") {
                  if (dueDate < todayDate) {
                    deadlineStatus = "OVERDUE";
                  } else if (dueDate === todayDate) {
                    deadlineStatus = "TODAY";
                  }
                }

                const assignees = getAssignees(task);
                const isNewAssignedTask = isRecentlyAssignedToMe(task);

                return (
                  <motion.div
                    key={task.id}
                    className={`relative overflow-hidden rounded-[20px] p-5 backdrop-blur-2xl bg-white/5 border shadow-[0_10px_40px_rgba(0,0,0,0.35)] hover:bg-white/2 transition-all duration-300 flex-shrink-0 w-[220px] ${
                      isNewAssignedTask
                        ? "uptask-new-task-card border-yellow-200/80"
                        : "border-white/20"
                    }`}
                    whileHover={{ scale: 1.03 }}
                    onClick={() => setSelectedTask(task)}
                  >
                    {isNewAssignedTask && (
                      <span className="absolute left-3 top-3 z-20 rounded-full border border-yellow-100/80 bg-yellow-300 px-2.5 py-1 text-[9px] font-black uppercase tracking-[0.18em] text-[#3b2200] shadow-[0_0_18px_rgba(250,204,21,0.75)]">
                        New
                      </span>
                    )}
                    {/* Action Icons */}
                    <div className="absolute top-2 right-3 flex items-center gap-1 z-10">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          togglePin(task.id);
                        }}
                        className="p-1 bg-white/10 rounded-full hover:bg-white/20 transition"
                      >
                        {pinnedTasks.includes(task.id) ? (
                          <PinOff size={14} className="text-yellow-400" />
                        ) : (
                          <Pin size={14} className="text-white" />
                        )}
                      </button>

                      <div className="relative">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenMenuId(openMenuId === task.id ? null : task.id);
                          }}
                          className="py-1 rounded-full hover:bg-white/20"
                        >
                          <MoreVertical size={14} className="text-white" />
                        </button>

                        {openMenuId === task.id && (
                          <div className="absolute right-0 bg-[#1e1447]/80 border border-white/20 rounded-lg shadow-lg overflow-hidden z-50">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setEditingTask(task);
                                setEditData({
                                  title: task.title || "",
                                  description: task.description || "",
                                  status: task.status || "",
                                  due_date: getDateInputValue(task.due_date),
                                  reason: "",
                                });
                                setOpenMenuId(null);
                              }}
                              className="w-full text-left px-3 py-2 text-sm hover:bg-white/10"
                            >
                              <Pencil size={14} className="text-white" />
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteTaskId(task.id);
                                setOpenMenuId(null);
                              }}
                              className="w-full text-left px-3 py-2 text-sm text-red-400 hover:bg-white/10"
                            >
                              <Trash2 size={14} className="text-red-400" />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="absolute -top-16 -right-16 w-40 h-40 bg-white/50 rounded-full blur-2xl opacity-50 pointer-events-none"></div>

                    {/* Assignee Info */}
                    <div className={`flex items-center gap-2 ${isNewAssignedTask ? "mt-5" : "mt-[-8px]"}`}>
                      {assignees.length > 0 ? (
                        <>
                          {assignees[0].pic ? (
                            <img
                              src={`${IMAGE_BASE_URL}${assignees[0].pic}`}
                              className="w-8 h-8 rounded-full object-cover border border-white/20"
                              alt=""
                            />
                          ) : (
                            <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs">
                              {assignees[0].name?.charAt(0).toUpperCase()}
                            </div>
                          )}
                          <p className="text-xs text-gray-300 truncate max-w-[100px]">{assignees[0].name}</p>
                        </>
                      ) : (
                        <p className="text-xs text-gray-400">Unassigned</p>
                      )}
                    </div>

                    {/* Title & Subtasks */}
                    <div className="flex justify-between items-start mt-2 gap-2">
                      <h4 title={task.title} className="text-white font-semibold text-sm line-clamp-2 flex-1">
                        {task.title}
                      </h4>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedSubtaskTask(task);
                        }}
                        className="bg-purple-500/20 font-bold text-purple-300 text-[10px] px-2 py-1 shadow-lg rounded-full border border-purple-400/30 hover:bg-purple-500/30 transition whitespace-nowrap"
                      >
                        SUBTASKS
                      </button>
                    </div>

                    {/* Description */}
                    <p className={`text-gray-400 text-[12px] mt-2 ${expandedTasks.includes(task.id) ? "" : "line-clamp-2"}`}>
                      {task.description}
                    </p>
                    {task.description?.length > 20 && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleDescription(task.id);
                        }}
                        className="text-cyan-400 text-[9px] mt-1 hover:underline block"
                      >
                        {expandedTasks.includes(task.id) ? "Show Less" : "Show More"}
                      </button>
                    )}

                    {/* Dates */}
                    <div className="flex justify-between text-xs text-gray-400 mt-4">
                      <div>
                        <p className="text-[10px] opacity-60">Start Date</p>
                        <p className="text-gray-300 text-[9px] whitespace-nowrap">{formatDisplayDateTime(task.created_at, "--")}</p>
                      </div>
                      <div>
                        <p className="text-[10px] opacity-60 text-right">End Date</p>
                        <p className="text-gray-300 text-[9px] text-right whitespace-nowrap">{formatDisplayDateTime(task.due_date, "--")}</p>
                      </div>
                    </div>

                    {/* Progress */}
                    {task.status !== "PENDING" && (() => {
                      let pct = 40;
                      if (task.status === "DONE") {
                        pct = 100;
                      } else if (task.progress) {
                        pct = Number(task.progress);
                      } else if (task.created_at && task.due_date) {
                        const start = new Date(task.created_at.replace(" ", "T"));
                        const end = new Date(task.due_date.replace(" ", "T"));
                        const now = new Date();
                        const total = end - start;
                        const passed = now - start;
                        if (total > 0) pct = Math.min(Math.max(Math.round((passed / total) * 100), 5), 95);
                      }
                      return (
                        <div className="w-full mt-3">
                          <div className="w-full h-1 bg-white/10 rounded-full overflow-hidden">
                            <div
                              className="h-1 bg-gradient-to-r from-cyan-400 to-blue-500 transition-all duration-700"
                              style={{ width: `${pct}%` }}
                            />
                          </div>
                          <p className="text-[9px] text-gray-400 mt-1 text-right">{pct}%</p>
                        </div>
                      );
                    })()}


                    {/* Status & Deadline Badges */}
                    <div className="flex items-center justify-end mt-4 gap-2">
                      {deadlineStatus && (
                        <div className="group relative">
                          <span
                            className={`text-[8px] px-2 py-1 rounded-lg shadow-lg font-bold ${deadlineStatus === "OVERDUE"
                              ? "bg-red-500 text-white"
                              : "bg-amber-500 text-white"
                              }`}
                          >
                            {deadlineStatus}
                          </span>
                          <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black/90 text-white text-[10px] px-2 py-1 rounded shadow-2xl backdrop-blur-md whitespace-nowrap z-50">
                            {deadlineStatus === "OVERDUE" ? "Task is overdue!" : "Due today!"}
                          </div>
                        </div>
                      )}
                      <span
                        className={`text-[8px] px-3 py-1 rounded-full font-medium backdrop-blur-md bg-white/10 shadow-lg border border-white/20 text-white ${task.status === "DONE"
                          ? "bg-green-500/20 text-green-400"
                          : task.status === "IN_PROGRESS"
                            ? "bg-cyan-500/20 text-cyan-400"
                          : task.status === "HOLD"
                            ? "bg-red-500/20 text-red-400"
                            : task.status === "PENDING"
                              ? "bg-orange-500/20 text-orange-400"
                              : "bg-blue-500/20 text-blue-400"
                          }`}
                      >
                        {task.status}
                      </span>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </>
        )}
      </div>
      <TaskDrawer
        task={selectedTask}
        open={!!selectedTask}
        onClose={() => setSelectedTask(null)}
        onStatusChange={(updated) => {
          setSelectedTask(updated);
          refreshTasks();
        }}
      />
      {/* ===== CREATE TASK MODAL ===== */}
      <CreateTaskModal
        open={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onCreated={refreshTasks}
      />

      {canViewTeamWork && (
        <div className="relative z-10 mt-6 overflow-hidden rounded-[24px] bg-white/[0.045] p-5 shadow-[0_22px_60px_rgba(0,0,0,0.24)] ring-1 ring-white/8">
          <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_12%_0%,rgba(34,211,238,0.10),transparent_34%),radial-gradient(circle_at_92%_16%,rgba(255,255,255,0.06),transparent_30%)]" />
          <div className="relative flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <button
              type="button"
              onClick={() => setTeamDailyOpen((value) => !value)}
              className="flex min-w-0 items-center gap-3 text-left"
            >
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-cyan-300/12 text-cyan-100 shadow-[inset_0_1px_0_rgba(255,255,255,0.12)]">
                <ClipboardCheck className="h-6 w-6" />
              </span>
              <span className="min-w-0">
                <span className="block text-xl font-black text-white">Team Work Overview</span>
                <span className="block text-sm text-white/52">
                  Today plans and assigned project tasks from your reporting team
                </span>
              </span>
              <ChevronDown
                className={`h-5 w-5 shrink-0 text-white/60 transition ${teamDailyOpen ? "rotate-180" : ""}`}
              />
            </button>

            <div className="flex flex-col gap-3 sm:flex-row">
              <label className="flex h-11 items-center gap-2 rounded-2xl bg-white/8 px-3 text-sm text-white/78 shadow-[inset_0_1px_0_rgba(255,255,255,0.10)] ring-1 ring-white/8">
                <Search className="h-4 w-4 text-cyan-200" />
                <input
                  value={teamWorkTab === "TODAY" ? teamDailySearch : teamTaskSearch}
                  onChange={(event) =>
                    teamWorkTab === "TODAY"
                      ? setTeamDailySearch(event.target.value)
                      : setTeamTaskSearch(event.target.value)
                  }
                  placeholder={teamWorkTab === "TODAY" ? "Search work..." : "Search assigned task..."}
                  className="w-32 bg-transparent text-white outline-none placeholder:text-white/38"
                />
              </label>
              {teamWorkTab === "TODAY" && (
                <label className="flex h-11 items-center gap-2 rounded-2xl bg-white/8 px-3 text-sm text-white/78 shadow-[inset_0_1px_0_rgba(255,255,255,0.10)] ring-1 ring-white/8">
                  <CalendarDays className="h-4 w-4 text-cyan-200" />
                  <input
                    type="date"
                    value={teamDailyDate}
                    onChange={(event) => setTeamDailyDate(event.target.value)}
                    className="bg-transparent text-white outline-none [color-scheme:dark]"
                  />
                </label>
              )}
              <select
                value={selectedTeamMember}
                onChange={(event) => setSelectedTeamMember(event.target.value)}
                className="h-11 rounded-2xl bg-[#211744]/90 px-4 text-sm font-bold text-white outline-none shadow-[inset_0_1px_0_rgba(255,255,255,0.10)] ring-1 ring-white/8"
              >
                <option value="ALL">All team members</option>
                {teamMemberOptions.map((member) => (
                  <option key={member.id} value={member.id}>
                    {member.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {teamDailyOpen && (
            <div className="relative mt-5">
              <div className="mb-5 inline-flex rounded-2xl bg-black/14 p-1 shadow-inner ring-1 ring-white/8">
                {[
                  { key: "TODAY", label: "Today Plan", count: visibleTeamDailyLogs.length },
                  { key: "ASSIGNED", label: "Assigned Tasks", count: visibleTeamTasks.length },
                ].map((tab) => (
                  <button
                    key={tab.key}
                    type="button"
                    onClick={() => setTeamWorkTab(tab.key)}
                    className={`rounded-xl px-4 py-2 text-xs font-black transition ${
                      teamWorkTab === tab.key
                        ? "bg-cyan-300 text-[#140a31] shadow-[0_10px_24px_rgba(34,211,238,0.28)]"
                        : "text-white/58 hover:bg-white/8 hover:text-white"
                    }`}
                  >
                    {tab.label}
                    <span className="ml-2 rounded-full bg-white/14 px-2 py-0.5 text-[10px]">
                      {tab.count}
                    </span>
                  </button>
                ))}
              </div>

              {teamWorkTab === "TODAY" ? (
                <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                  {visibleTeamDailyLogs.length === 0 ? (
                    <div className="rounded-[20px] bg-black/10 p-6 text-sm text-white/50 ring-1 ring-white/8 md:col-span-2 xl:col-span-3">
                      No daily work updates found for this date.
                    </div>
                  ) : (
                    visibleTeamDailyLogs.map((log) => {
                      const userName = getFullName(log.user);
                      const profilePic = log.user?.profile_pic;
                      const title = log.task_title || log.custom_title || "Daily work";

                      return (
                        <div
                          key={log.id}
                          className="overflow-hidden rounded-[22px] bg-[#21183e]/82 p-4 shadow-[0_18px_46px_rgba(0,0,0,0.22)] ring-1 ring-white/8"
                        >
                          <div className="flex items-center gap-3">
                            {profilePic ? (
                              <img
                                src={`${IMAGE_BASE_URL}${profilePic}`}
                                alt=""
                                className="h-12 w-12 rounded-2xl object-cover ring-1 ring-white/14"
                              />
                            ) : (
                              <div className="grid h-12 w-12 place-items-center rounded-2xl bg-violet-600/80 text-sm font-black text-white">
                                {userName.charAt(0)}
                              </div>
                            )}
                            <div className="min-w-0">
                              <p className="truncate text-base font-black text-white">{userName}</p>
                              <p className="truncate text-xs font-bold uppercase tracking-[0.16em] text-cyan-100/50">
                                {log.user?.job_title || "Team member"}
                              </p>
                            </div>
                          </div>

                          <div className="mt-4 rounded-2xl bg-white/[0.045] p-3">
                            <p className="text-[10px] font-black uppercase tracking-[0.2em] text-cyan-100/54">
                              Today task
                            </p>
                            <h3 className="mt-1 line-clamp-2 text-lg font-black text-white">{title}</h3>
                            <p className="mt-2 line-clamp-4 text-sm leading-6 text-white/62">
                              {log.morning_description || "Morning plan not submitted."}
                            </p>
                            {log.extra_details && (
                              <p className="mt-2 rounded-xl bg-white/[0.045] px-3 py-2 text-xs leading-5 text-white/48">
                                {log.extra_details}
                              </p>
                            )}
                          </div>

                          <div className="mt-3 rounded-2xl bg-white/[0.035] p-3">
                            <p className="text-[10px] font-black uppercase tracking-[0.2em] text-amber-100/60">
                              Punch-out summary
                            </p>
                            <p className="mt-2 line-clamp-4 text-sm leading-6 text-white/62">
                              {log.punch_out_description || "Waiting for end-of-day update."}
                            </p>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              ) : (
                <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                  {visibleTeamTasks.length === 0 ? (
                    <div className="rounded-[20px] bg-black/10 p-6 text-sm text-white/50 ring-1 ring-white/8 md:col-span-2 xl:col-span-3">
                      No assigned project tasks found.
                    </div>
                  ) : (
                    visibleTeamTasks.map((task) => {
                      const assignees = getAssignees(task);
                      const owner = assignees.find((assignee) => !isLoggedInUser(assignee.id)) || {
                        name: task.creator || "Team member",
                        pic: task.creator_profile_pic,
                      };
                      const dueDate = formatDisplayDateTime(task.due_date, "--");

                      return (
                        <button
                          key={`team-task-${task.id}`}
                          type="button"
                          onClick={() => setSelectedTask(task)}
                          className="group overflow-hidden rounded-[22px] bg-[#21183e]/82 p-4 text-left shadow-[0_18px_46px_rgba(0,0,0,0.22)] ring-1 ring-white/8 transition hover:-translate-y-1 hover:bg-[#2a2050]"
                        >
                          <div className="flex items-center gap-3">
                            {owner.pic ? (
                              <img
                                src={`${IMAGE_BASE_URL}${owner.pic}`}
                                alt=""
                                className="h-12 w-12 rounded-2xl object-cover ring-1 ring-white/14"
                              />
                            ) : (
                              <div className="grid h-12 w-12 place-items-center rounded-2xl bg-violet-600/80 text-sm font-black text-white">
                                {owner.name?.charAt(0) || "T"}
                              </div>
                            )}
                            <div className="min-w-0">
                              <p className="truncate text-base font-black text-white">{owner.name}</p>
                              <p className="truncate text-xs font-bold uppercase tracking-[0.16em] text-cyan-100/50">
                                {owner.job_title || `${assignees.length || 1} assignee${assignees.length > 1 ? "s" : ""}`}
                              </p>
                            </div>
                          </div>

                          <h4 className="mt-4 line-clamp-2 text-lg font-black text-white">
                            {task.title}
                          </h4>
                          <p className="mt-2 line-clamp-3 min-h-[4.5rem] text-sm leading-6 text-white/58">
                            {task.description || "No description added."}
                          </p>
                          <div className="mt-4 flex items-center justify-between gap-3">
                            <span className="rounded-full bg-white/8 px-3 py-1 text-[11px] font-bold text-white/70 ring-1 ring-white/8">
                              Due {dueDate}
                            </span>
                            <span className="rounded-full bg-cyan-200/10 px-3 py-1 text-[11px] font-black text-cyan-100 ring-1 ring-cyan-200/12">
                              {String(task.status || "TODO").replace("_", " ")}
                            </span>
                          </div>
                        </button>
                      );
                    })
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}









      {editingTask &&
        createPortal(
          <div className="fixed inset-0 z-[9999] flex items-center justify-center">

            {/* Backdrop */}
            <div
              onClick={() => setEditingTask(null)}
              className="absolute inset-0 bg-black/60 backdrop-blur-md animate-fadeIn"
            />

            {/* Glass Modal */}
            <div className="
        relative
        w-[420px]
        max-w-[95%]
        rounded-xl
        bg-white/10
        backdrop-blur-xl
        border border-white/20
        shadow-[0_20px_60px_rgba(0,0,0,0.5)]
        p-6
        text-white
        animate-scaleIn
        shadow-lg
      ">

              {/* Floating glow */}
              <div className="absolute -top-20 -right-20 w-60 h-60 bg-purple-500/30 rounded-full blur-3xl pointer-events-none" />

              {/* Header */}
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl  font-sans-serif font-semibold tracking-wide">
                  Edit Task
                </h3>

                <button
                  onClick={() => setEditingTask(null)}
                  className="text-white/70 hover:text-white transition"
                >
                  ✕
                </button>
              </div>

              {/* Title */}
              <div className="mb-1">
                <label className="text-sm text-white/70">Title</label>
                <input
                  type="text"
                  value={editData.title}
                  onChange={(e) =>
                    setEditData({ ...editData, title: e.target.value })
                  }
                  className="
              w-full mt-1
              bg-white/10
              border border-white/20
              rounded-[8px]
              px-4 py-2
              text-white
              placeholder-white/40
              focus:outline-none
              focus:border-cyan-400
              transition
              shadow-lg
            "
                  placeholder="Enter title"
                />
              </div>

              {/* Description */}
              <div className="mb-1">
                <label className="text-sm text-white/70">Description</label>
                <textarea
                  value={editData.description}
                  onChange={(e) =>
                    setEditData({ ...editData, description: e.target.value })
                  }
                  rows={3}
                  className="
              w-full mt-1
              bg-white/10
              border border-white/20
              rounded-[8px]
              px-4 py-2
              text-white
              placeholder-white/40
              focus:outline-none
              focus:border-cyan-400
              transition
              shadow-lg
            "
                  placeholder="Enter description"
                />
              </div>


              <div className="mb-3">
                <label className="text-sm text-white/70">End Date</label>
                <input
                  type="date"
                  value={editData.due_date}
                  onChange={(e) =>
                    setEditData({ ...editData, due_date: e.target.value })
                  }
                  className="w-full mt-1 bg-white/10 border border-white/20 rounded-[8px] px-4 py-2 text-white"
                />
              </div>


              {/* {editData.due_date !== editingTask?.due_date && ( */}

              {editData.due_date !== getDateInputValue(editingTask?.due_date) && (
                <div className="mb-4">
                  <label className="text-sm text-white/70">
                    Reason (required if date changed)
                  </label>


                  <textarea
                    value={editData.reason}
                    onChange={(e) => {
                      setEditData({ ...editData, reason: e.target.value });
                      setShowReasonError(false); // remove error when typing
                    }}
                    className={`
    w-full mt-1
    bg-white/10
    border
    ${showReasonError ? "border-red-500" : "border-white/20"}
    rounded-[8px]
    px-4 py-2
    text-white
  `}
                    placeholder="Enter reason"
                  />

                  {showReasonError && (
                    <p className="text-red-400 text-xs mt-1">
                      Reason is required when changing end date
                    </p>
                  )}






                </div>
              )}

              {/* Status */}
              <div className="mb-6">
                <label className="text-sm text-white/70">Status</label>
                <select
                  value={editData.status}
                  onChange={(e) =>
                    setEditData({ ...editData, status: e.target.value })
                  }



                  className="
              w-full mt-1
              bg-white/10
              border border-white/20
              rounded-[8px]
              px-4 py-2
              text-white
              focus:outline-none
              focus:border-cyan-400
              transition
              shadow-lg
            "
                >
                  <option value="PENDING" className="bg-[#1e1447]">PENDING</option>
                  <option value="IN_PROGRESS" className="bg-[#1e1447]">IN_PROGRESS</option>
                  <option value="DONE" className="bg-[#1e1447]">DONE</option>
                </select>
              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setEditingTask(null)}
                  className="
              px-5 py-2
              rounded-[8px]
              bg-white/10
              border border-white/20
              hover:bg-white/20
              transition
              shadow-lg
            "
                >
                  Cancel
                </button>

                <button
                  onClick={handleUpdate}
                  className="
              px-5 py-2
              rounded-[10px]
              bg-gradient-to-r
              from-cyan-500
              to-blue-500
              hover:scale-105
              transition-all
              shadow-lg
            "
                >
                  Update
                </button>
              </div>

            </div>
          </div>,
          document.body
        )}




      {selectedSubtaskTask &&
        createPortal(
          <div className="fixed inset-0 z-[9999] flex items-center justify-center">

            {/* Glass Backdrop */}
            <div
              className="absolute inset-0 bg-black/60 backdrop-blur-md animate-fadeIn"
              onClick={() => setSelectedSubtaskTask(null)}
            />

            {/* Glass Modal */}
            <div
              className="
        relative
        w-[520px]
        max-w-[95%]
        rounded-[20px]
        bg-white/10
        backdrop-blur-2xl
        border border-white/20
        shadow-[0_20px_60px_rgba(0,0,0,0.6)]
        p-6
        text-white
        animate-scaleIn
        overflow-hidden
       
      "
            >

              {/* Floating Glow */}
              <div className="absolute -top-20 -right-20 w-60 h-60 bg-purple-500/30 rounded-full blur-3xl pointer-events-none"></div>
              <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-cyan-400/30 rounded-full blur-3xl pointer-events-none"></div>

              {/* Header */}
              <div className="flex justify-between items-center mb-3">
                <h3 className="text-xl font-semibold tracking-wide">
                  Subtasks - {selectedSubtaskTask.title}
                </h3>

                <button
                  onClick={() => setSelectedSubtaskTask(null)}
                  className="text-white/70 hover:text-white transition text-lg"
                >
                  ✕
                </button>
              </div>
              {/* Task Title */}
              {/* <p className="text-sm text-white/70 mb-4">
          {selectedSubtaskTask.title}
        </p> */}

              {/* Subtask List */}
              <div className="max-h-[320px] overflow-y-auto pr-1 space-y-3 custom-scrollbar">
                <TaskSubtasks taskId={selectedSubtaskTask.id} />
              </div>

            </div>
          </div>,
          document.body
        )}


      {showSuccessModal &&
        createPortal(
          <div className="fixed inset-0 z-[9999] flex items-center justify-center">

            {/* backdrop */}
            <div
              className="absolute inset-0 bg-black/60 backdrop-blur-md"
              onClick={() => setShowSuccessModal(false)}
            />

            {/* modal */}
            <div className="relative w-[350px] rounded-xl bg-white/10 backdrop-blur-xl border border-white/20 p-6 text-white text-center shadow-2xl">

              <h2 className="text-xl font-semibold mb-3">
                ✅ Successfully Updated
              </h2>

              <p className="text-sm text-white/70 mb-5">
                Your task has been updated successfully.
              </p>

              <button
                onClick={() => setShowSuccessModal(false)}
                className="px-5 py-2 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-lg"
              >
                OK
              </button>
            </div>
          </div>,
          document.body
        )}







      {deleteTaskId &&
        createPortal(
          <div className="fixed inset-0 z-[9999] flex items-center justify-center">

            <div
              className="absolute inset-0 bg-black/60 backdrop-blur-md"
              onClick={() => setDeleteTaskId(null)}
            />

            <div className="relative w-[350px] rounded-xl bg-white/10 backdrop-blur-xl border border-white/20 p-6 text-white text-center">

              <h2 className="text-lg mb-3">Delete Task?</h2>
              <p className="text-sm text-white/70 mb-5">
                Are you sure you want to delete this task?
              </p>

              <div className="flex justify-center gap-3">
                <button
                  onClick={() => setDeleteTaskId(null)}
                  className="px-4 py-2 bg-white/10 rounded"
                >
                  Cancel
                </button>

                <button
                  onClick={async () => {
                    try {
                      await deleteTaskApi(deleteTaskId);
                      setDeleteTaskId(null);
                      setShowDeleteSuccess(true);
                      refreshTasks();
                    } catch {
                      toast.error("Delete failed");
                    }
                  }}
                  className="px-4 py-2 bg-red-500 rounded"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}




      {showDeleteSuccess &&
        createPortal(
          <div className="fixed inset-0 z-[9999] flex items-center justify-center">

            <div className="absolute inset-0 bg-black/60 backdrop-blur-md" />

            <div className="relative w-[320px] rounded-xl bg-white/10 backdrop-blur-xl border border-white/20 p-6 text-white text-center">

              <h2 className="text-lg mb-3">🗑 Deleted</h2>

              <button
                onClick={() => setShowDeleteSuccess(false)}
                className="px-4 py-2 bg-gradient-to-r from-red-500 to-pink-500 rounded"
              >
                OK
              </button>
            </div>
          </div>,
          document.body
        )}


    </div>
  );
}
